import React, { useEffect, useState } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";

// แถบธนาคาร PARTNERSHIP CASINO — ดึงรายชื่อ/โลโก้ธนาคารจริงจาก mainsetting (tblbank)
// เว็บลาวก็จะได้ธนาคารลาวตามที่ตั้งไว้ใน DB ของเว็บนั้นเอง
const PartnershipCasino = () => {
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    let alive = true;
    instance
      .post("/api/v1/mainsetting", { System: Systems })
      .then((res) => {
        if (!alive) return;
        if (res.data && res.data.status === 200 && Array.isArray(res.data.tblbank)) {
          // เอาเฉพาะที่มีรูปโลโก้
          setBanks(res.data.tblbank.filter((b) => b && b.img_path));
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!banks.length) return null;

  return (
    <div style={{ padding: "20px", color: "#fff" }}>
      <div className="elementor-widget-container">   PARTNERSHIP CASINO	</div>
      <div
        style={{
          display: "grid",
          marginTop: "15px",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "10px",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        {banks.map((b, index) => (
          <div key={b.bank_id || index} style={{ width: "35px", height: "35px" }}>
            <img
              src={b.img_path}
              alt={b.fullname_th || `bank ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "50%",
                backgroundColor: "#00000094",
                padding: "3px",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnershipCasino;
